import React from 'react'

function ProfileSettings() {
  return (
    <div>ProfileSettings</div>
  )
}

export default ProfileSettings